module.exports = __webpack_public_path__ + "img/SDG-01-EN.d721c679.png";